import { ReactNode } from "react";

import { extractDuplicateLoadUrl, normalizeApiError } from "./apiError";

// Renders a normalized API error for a toast. Error messages are sanitized (HTML stripped) by
// normalizeApiError, so for a duplicate load number we re-attach the link as a real anchor
// element rather than injecting HTML, keeping the clickable "here" without a dangerouslySetInnerHTML.
export function renderApiErrorMessage(error: unknown): string | ReactNode {
  const normalized = normalizeApiError(error);
  if (normalized.domain === "DUPLICATE_LOAD_NUMBER") {
    const url = extractDuplicateLoadUrl(error);
    const segments = normalized.message.split(/\bhere\b/i);
    if (url && segments.length === 2) {
      return (
        <span>
          {segments[0]}
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-semibold">
            here
          </a>
          {segments[1]}
        </span>
      );
    }
  }
  return normalized.message;
}
